export default __webpack_public_path__ + "static/media/red-rake-gaming-casino.9c42065e.svg";